class TabSlider {
    constructor(container) {
        this.container = container;
        this.tabs = Array.from(container.querySelectorAll('.tab-slider-button'));
        this.slideBar = container.querySelector('.tab-slide');
        this.track = container.querySelector('.tab-slider-item-list');
        this.panels = Array.from(this.track.querySelectorAll('.tab-slider-item'));

        this.current = 0;
        this.currentScroll = 0;
        this.onResize = this.onResize.bind(this);

        this.calcWidths();
        this.bindEvents();
    }

    // Breiten einmal berechnen
    calcWidths() {
        const margin = (element) => {
            const style = getComputedStyle(element);
            return parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        };

        // erste Karte kann andere Breite/Margin haben
        this.firstWidth = this.panels[0].offsetWidth + margin(this.panels[0]);
        this.stepWidth = this.panels[1]
            ? this.panels[1].offsetWidth + margin(this.panels[1])
            : this.firstWidth;
        this.maxWidth = this.stepWidth * (this.panels.length - 2) + this.firstWidth;
    }

    bindEvents() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', (event) => this.onTabClick(event));
            tab.addEventListener('keydown', (event) => this.onTabKeydown(event));
        });

        window.addEventListener('resize', this.onResize);
    }

    onResize() {
        this.calcWidths();
        this.setActive(0, false);
    }

    static isDesktop() {
        return window.innerWidth > 1044;
    }

    onTabClick(event) {
        if (!TabSlider.isDesktop()) {
            return;
        }

        const index = this.tabs.indexOf(event.currentTarget);

        if (index !== this.current) {
            this.setActive(index);
        }
    }

    onTabKeydown(e) {
        switch (e.key) {
            case 'ArrowRight':
                e.preventDefault();
                this.setActive((this.current + 1) % this.tabs.length);
                break;
            case 'ArrowLeft':
                e.preventDefault();
                this.setActive((this.current - 1 + this.tabs.length) % this.tabs.length);
                break;
            case 'Tab':
                // Browser springt automatisch: only active tab is focusable (tabindex=0)
                break;
            default:
                break;
        }
    }

    setActive(newIndex, focusItem = true) {
        this.current = newIndex;

        this.tabs.forEach((tab, index) => {
            const isSelected = index === newIndex;

            tab.classList.toggle('active', isSelected);
            tab.setAttribute('aria-selected', isSelected);
            tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        this.panels.forEach((panel, index) => {
            panel.classList.toggle('active', index === newIndex);
        });

        // Track/Slide verschieben
        const scrollX = this.computeScroll(newIndex);

        this.track.style.transform = `translateX(${-scrollX}px)`;

        // Markierung für aktiven Tab bewegen
        this.moveSlideBar(this.tabs[newIndex]);

        if (focusItem) {
            this.tabs[newIndex].focus();
        }
    }

    computeScroll(index) {
        const width = Math.max(0, Math.min(this.firstWidth + this.stepWidth * (index - 1), this.maxWidth));

        this.currentScroll = width;
        return width;
    }

    moveSlideBar(tab) {
        const tabRect = tab.getBoundingClientRect();

        const nav = this.container.querySelector('.tab-slider-navigation');
        const navRect = nav.getBoundingClientRect();

        this.slideBar.style.left = `${tabRect.left - navRect.left}px`;
        this.slideBar.style.width = `${tabRect.width}px`;
    }
}

// initialisieren
export default function initTabSlider() {
    const tabSliders = document.querySelectorAll('.js-tab-list');

    tabSliders.forEach((tabSlider) => {
        return new TabSlider(tabSlider);
    });
}
